import React from 'react';
import clsx from 'clsx';
import { PlateElement } from 'platejs/react';
import styles from './ColumnGroupElement.module.scss';

// Renders `column_group` — a flex row of `column` children. Each child
// reads its `width` percentage from its own node. The withColumn
// normalizer (in @platejs/layout) keeps widths summing to 100%.
export const ColumnGroupElement = React.memo(function ColumnGroupElement(props: any) {
    return (
        <PlateElement {...props} as="div" className={clsx(props.className, styles.columnGroup)}>
            {props.children}
        </PlateElement>
    );
});
